import React from 'react';

import './Sevenday.css';

import * as bootstrap from 'react-bootstrap';

import ReactImageFallback from "react-image-fallback";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// date formate
// import Moment from 'moment';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import Cookies from 'universal-cookie';

// import ReactImageFallback from "react-image-fallback";
class SevendayChapter extends React.Component{
    constructor(props){
        super(props); 
        this.state = {
            error: null,
            sevenday_chapters: [],
            bookInterests: [],
            specialDeals: [],
        };
    }

    componentDidMount(){
        
        const cookies = new Cookies();

        const apiUrl = cookies.get('baseUrlApi')+'sevenday/sevenday_chapter/'+this.props.bookid+'/'+this.props.chapterid;

        fetch(apiUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        sevenday_chapters: result.sevenday_chapter,
                        bookInterests: result.bookInterest,
                        specialDeals: result.specialDeal
                        // tophits: result.tophit,
                    })
                },
                (error) => {
                    this.setState({ error })
                }
            )
    }
    
    render() {
        const cookies = new Cookies();

        const {error, sevenday_chapters ,bookInterests ,specialDeals} = this.state;
        // const {error, blogs , blogReleateds , tophits} = this.state;
        
        var HtmlToReactParser = require('html-to-react').Parser;
        var htmlToReactParser = new HtmlToReactParser();


        const book_Interests = {
            dots: true,
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5, 
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                    }
                }
            ]
        };


        const specialDeal = {
            dots: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3, 
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                    }
                }
            ]
        };

        if(error){
            return(
                <div>Error: {error.message}</div>
            )
        }else{
            return (
                <div>
                    <Header />

                    <bootstrap.Container style={{}}>
                        <bootstrap.Row>
                            {sevenday_chapters.map(sevenday_chapter => { 
                                return  <bootstrap.Col md={12} key={sevenday_chapter.id}>
                                            <bootstrap.Col className="book_content" xs={12} md={12}>
                                                <h2>{sevenday_chapter.book_name}</h2>
                                                <p style={{color:"#666"}}>{sevenday_chapter.day_at}</p>
                                            </bootstrap.Col>
                                            <h3 style={{marginTop:"50px",borderBottom: "3px solid red"}}>{sevenday_chapter.chapter_name}</h3>
                                            <bootstrap.Col className="book_content" xs={12} md={12} style={{paddingTop:"0px"}}>
                                                {htmlToReactParser.parse(sevenday_chapter.chapter_detail)}
                                            </bootstrap.Col>
                                        </bootstrap.Col>
                            })}
                        </bootstrap.Row>
                    </bootstrap.Container>

                    
                    <div style={{borderTop:"1px solid #ddd",padding:"50px 0px"}}>
                        <bootstrap.Container style={{paddingTop: "30px" ,paddingBottom: "30px"}}>
                            {/* <bootstrap.Row>
                                <bootstrap.Col md={12}> */}
                                    <h3 className=""><font style={{borderBottom: "3px solid red"}}>หนังสือแนะนำ</font></h3><br/> 
                                    <Slider {...book_Interests} >
                                        {bookInterests.map(bookInterest => (
                                            <div key={bookInterest.id}>
                                                <div style={{margin:"0px 15px"}}>
                                                    <a href={`${cookies.get('baseUrl')}book/${bookInterest.id}`}>
                                                        <ReactImageFallback src={`${cookies.get('baseUrlImage')}${bookInterest.book_pic}`} fallbackImage={`https://www.smmpublishing.com/images/products/${bookInterest.book_pic}`} alt={bookInterest.book_name} className="regular_img" width="100%" />
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                {/* </bootstrap.Col>
                            </bootstrap.Row> */}
                        </bootstrap.Container>
                    </div>

                    
                    <div style={{borderTop:"1px solid #ddd",padding:"50px 0px"}}>
                        <bootstrap.Container style={{paddingTop: "30px" ,paddingBottom: "30px"}}>
                            <h3 className=""><font style={{borderBottom: "3px solid red"}}>Special Deal</font></h3><br/> 
                            <Slider {...specialDeal} >
                                {specialDeals.map(specialDeal => (
                                    <div key={specialDeal.id}>
                                        <div style={{margin:"0px 15px"}} className="tophit_margin">
                                            <a href={specialDeal.linked}>
                                                <ReactImageFallback src={`${cookies.get('baseUrlImage')}${specialDeal.picture}`} fallbackImage={`https://www.smmpublishing.com/images/special/${specialDeal.picture}`} alt={specialDeal.topic} className="img_specialDeal" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </bootstrap.Container>
                    </div>


                    {/* <div style={{borderTop:"1px solid #ddd",padding:"50px 0px",backgroundColor:"#fbfbfb"}}>
                        <bootstrap.Container>
                            <bootstrap.Row>
                                <bootstrap.Col md={12}>
                                    <h3 style={{textAlign:"center"}}><font style={{borderBottom: "3px solid red"}}>แนะนำ</font></h3><br/> 
                                    
                                    <bootstrap.Row>
                                            {tophits.map(tophit => (
                                                <bootstrap.Col key={tophit.id} xs={6} sm={6} md={3} lg={3} className="" style={{width:"100%"}}>
                                                    <a href={`http://localhost:3000/blog/${tophit.id}`}>
                                                        <ReactImageFallback
                                                        src={`${cookies.get('baseUrlImage')}${tophit.images}`}
                                                        fallbackImage={`https://www.smmpublishing.com/images/products/${tophit.images}`}
                                                        initialImage="loader.gif"
                                                        alt={tophit.post_title}
                                                        className="" style={{border:"1px solid #ddd"}} width="100%"/>
                                                    </a>
                                                </bootstrap.Col>
                                            ))} 
                                        
                                    </bootstrap.Row>

                                </bootstrap.Col>
                            </bootstrap.Row>
                        </bootstrap.Container>
                    </div> */}

                    <Footer />
                </div>
            );   
        }
    }
}

export default SevendayChapter;